
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import { useAnalytics } from '@/hooks/useAnalytics';
import { useConversionTracking } from '@/hooks/useConversionTracking';

const FloatingCTA = () => {
  const navigate = useNavigate();
  const { trackCTAClick, trackOnboardingStart } = useAnalytics();
  const { trackCTAPerformance } = useConversionTracking();

  const handleGetEarlyAccess = () => {
    trackCTAClick('floating');
    trackOnboardingStart();
    trackCTAPerformance('floating-cta', 'click', 'floating_button');
    navigate('/early-access');
  };

  return (
    <>
      {/* Mobile Version - Bottom */}
      <div className="lg:hidden fixed bottom-6 left-4 right-4 z-50">
        <Button
          onClick={handleGetEarlyAccess}
          className="w-full bg-yellow-400 hover:bg-yellow-300 text-purple-900 font-black px-6 py-4 rounded-2xl shadow-2xl animate-pulse-gentle hover:scale-105 transition-all duration-300 text-sm cta"
          data-track="floating-cta"
        >
          Get Early Access
        </Button>
      </div>
    </>
  );
};

export default FloatingCTA;
